<template>
    <ListeCreance/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import ListeCreance from "@/components/GesCom/Creance/ListeCreance.vue";

    export default defineComponent({
      name: "ListeCreancePage",
      components: {
        
        ListeCreance,
      },
    });
  </script>